export default "__VITE_ASSET__DvRuKjBL__"